import React from 'react';
import './whydentist.css';
import Modal1 from '../../modal';

function Whydentistseo() {
    return (
        <div className='dentist-seo-container'>
            <p className='dentist-proven-text'>
                Technical <span className='dentist-text'>SEO Services</span> for Local Businesses
            </p>
            <p className='dentist-all-text'>
                Improve Your Search Rankings Without Adding Any New Content. In this competitive digital landscape, staying updated with the latest technical on-page SEO tactics and algorithm updates is crucial to boost your website’s profitability. Understanding what technical SEO involves and its requirements ensures your web pages are well-structured for both online users and search engine spiders.
            </p>
            <p className='dentist-all-text'>
                Technical SEO involves several key processes, including running a crawl error report, eliminating duplicate content, auditing the preferred domain, improving metadata, checking HTTPS status codes, and addressing broken links. Additionally, it includes creating an XML sitemap, implementing Secure Sockets Layer (SSL), increasing site speed, utilizing robots.txt, optimizing the website for mobile, auditing redirects, and performing a Google site search, among other tasks.
            </p>
            <p className='dentist-all-text'>
                We understand that navigating the complex requirements and processes of technical optimization SEO while managing your core business operations can be challenging. That’s why our technical SEO consultants are here to assist you. If your website’s technical on-page SEO functionality is affecting your organic search performance, let our technical SEO experts handle the hard work for you. Partner with Thrive for your SEO technical audit and optimization and unlock your growth potential.
            </p>
            <div style={{display:"flex",justifyContent:"center"}}>
                <Modal1 />
            </div>
        </div>
    );
}

export default Whydentistseo;
